import Icon from '@klv/atoms/icon';
import SideDownloadCta from '@klv/molecules/side-download-cta';
import ArticleTableOfContents from '@klv/organisms/article-table-of-contents';

import * as styles from './styles/sidebar.module.scss';
import useCopyUrl from './hooks/useCopyUrl';

import type { ISidebarProps } from './types';

const Sidebar = ({ h2List, hasSideDownloadCta, sideDownloadCta, windowLocation, showTableOfContents }: ISidebarProps) => {
  // used for sharing the URL to social media
  const encodedUrl = encodeURIComponent(windowLocation);
  
  // used for copying the URL to the clipboard
  const { showCopied, handleCopy } = useCopyUrl(windowLocation);

  return (
    <div className={styles.sidebar}>
      <div className={styles.sidebarStickyChildren}>
        {showTableOfContents && (
          <ArticleTableOfContents
            className={styles.tableOfContents}
            headingTag='h2'
            sections={h2List}
          />
        )}
        {hasSideDownloadCta && (
          <SideDownloadCta {...sideDownloadCta} />
        )}
        <div className={styles.socialIcons}>
          <button onClick={handleCopy} className={styles.shareLink} rel="noopener">
            <Icon iconName="Copy" className={styles.icon} fillColor="currentColor" />
          </button>
          {showCopied && <div className={styles.copiedText}>Copied!</div>}
          <a className={styles.shareLink} rel="noopener" href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}>
            <Icon className={styles.icon} iconName="Facebook" fillColor="currentColor" />
          </a>
          <a className={styles.shareLink} rel="noopener" href={`https://twitter.com/intent/tweet?url=${encodedUrl}`}>
            <Icon className={styles.icon} iconName="Twitter" fillColor="currentColor" />
          </a>
          <a className={styles.shareLink} rel="noopener" href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}>
            <Icon className={styles.icon} iconName="LinkedIn" fillColor="currentColor" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
